import generateConstantLifecycle from 'utils/generateConstantLifecycle';

export const READ_TEAM_BY_ORGANIZATION = 'READ_TEAM_BY_ORGANIZATION';
export const DEACTIVATE_USER = 'DEACTIVATE_USER';
export const INVITE_TEAM_MEMBER = 'INVITE_TEAM_MEMBER';
export const UPDATE_TEAM_MEMBER = 'UPDATE_TEAM_MEMBER';
export const REMOVE_USERS_FROM_BOARD = 'REMOVE_USERS_FROM_BOARD';

export const constants = {
  REMOVE_USERS_FROM_BOARD,
  ...generateConstantLifecycle(
    DEACTIVATE_USER,
    READ_TEAM_BY_ORGANIZATION,
    INVITE_TEAM_MEMBER,
    UPDATE_TEAM_MEMBER,
  ),
};
